import { ReponseApi } from './api.types';
import { ErreurApi } from './api-error';

export function extraireReponse<T>(res: ReponseApi<T>): T | null {
  verifierReponse(res);
  return res.reponse ?? null;
}

export function verifierReponse(res: ReponseApi): void {
  if (!res || typeof res.statut !== 'string' || !res.statut.trim()) {
    throw new ErreurApi('La réponse du serveur est invalide.', 'reponse_invalide');
  }
  if (res.statut.trim().toUpperCase() !== 'OK') {
    throw new ErreurApi(
      typeof res.message === 'string' && res.message.trim()
        ? res.message
        : 'La demande a été refusée par le serveur.',
      'metier',
      res.details,
    );
  }
}
